<template>
  <v-dialog
    persistent
    v-model="showDialog"
    max-width="1024px"
  >
  <v-card>
    <v-form ref="form" :lazy-validation="true">
      <v-card-title>
        <h4>ANTECKNINGAR</h4>
        <v-btn class="ml-6 mt-n4" @click="newNote" :disabled="!canCreateNotes">
          <v-icon class="mr-3">$sl-message</v-icon> Ny Anteckning
        </v-btn>

        <v-card-actions>
          <v-icon class="close" @click="close()">$sl-close</v-icon>
        </v-card-actions>

        <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            class="mt-n8 pr-4"
            clearable
            @click:clear="clearSearch"
            @keydown.enter="doSearch"
            prepend-icon="$sl-search"
            placeholder="Sök i listan"
            single-line
            hide-details
          ></v-text-field>
      </v-card-title>
    </v-form>
    <NotesList 
      v-if="showDialog" 
      :modifier="{ applicationId, personId }" 
      :search="searchcriteria"
      :comments="comments"
    />

  </v-card>
  </v-dialog>
</template>

<script>
import NotesList from '@/components/NotesList.vue'
import { CanIDo } from '@/components/mixins'

export default {
  mixins: [CanIDo],

  components: {
    NotesList
  },

  props: {
    applicationId: {
      type: Number,
      default: null
    },
     // Should dialog be showed
    show: {
     // `true` / `false`
      type: Boolean,
       // The default value is: `false`
      default: false
    },
    
    personId: {
      type: Number,
      default: null
    },

    comments: {
      type: Array,
      default: () => ([])
    }
  },

  data: () => ({
    searchcriteria: null,
    search: '',
    showDialog: false,
    notesModal: false
  }),

  watch: {
    show () {
      this.showDialog = this.show
    }
  },
  
  asyncComputed: {
    canCreateNotes(){
      return this.canIDo('notes', 'create');
    },
  },

  methods: {
    close () {
       // Fire close event 
      // @arg called with no argument , close the modal
      this.$emit('close')
    },

    newNote() {
      console.log('newNote')
      this.$emit('new')
    },

    clearSearch(e) {
      this.searchcriteria = null
      return false
    },

    doSearch(e) {
      e.preventDefault()
      this.searchcriteria = this.search
    }
  }
}
</script>

<style>
</style>